import { render, staticRenderFns } from "./LanguageChanger.vue?vue&type=template&id=7d4ee8eb&scoped=true"
import script from "./LanguageChanger.vue?vue&type=script&lang=js"
export * from "./LanguageChanger.vue?vue&type=script&lang=js"
import style0 from "./LanguageChanger.vue?vue&type=style&index=0&id=7d4ee8eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ee8eb",
  null
  
)

export default component.exports